import { Component, OnInit, ViewChild,ViewEncapsulation } from '@angular/core';
import { FormArray,FormGroup,FormControl, Validators } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { LoadService } from '../../services/load.service';
import { ProveedoresService } from '../../services/providers.service';
import { CountriesService } from '../../services/countries.service';
import { Provider } from '../../model/Provider';
import { FilterUrlService } from '../../services/filter-url.service';

@Component({
  selector: 'proveedor',
  templateUrl: './proveedores.component.html',
  styleUrls: ['./proveedores.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ProveedoresComponent implements OnInit {
  @ViewChild(ModalDirective) lgModal: ModalDirective;
  public primeracarga:boolean;
  public load:number;
  public isopen:boolean;
  public alert:string;
  public data_list:any[];
  public links: any;
  public meta: any;
  public title:string;
  public isNew:boolean;
  public signupForm:FormGroup;
  public item_to_update:number;
  public countries:any;
  public settings = {
    columns:{
      rut: { header: "Rut", type:"text",filter: { visible:true } },
      name: { header: "Nombre", type:"text",filter: { visible:true } },
      email: { header: "Email", type:"text",filter: { visible:true } },
      address: { header: "Direccion", type:"text",filter: { visible:true } },
      contact: { header: "Contacto", type:"text",filter: { visible:true } },
    },
    actions:{
      edit: true,
      view: false,
      delete: false
    }
  };

  constructor(private _providerService:ProveedoresService,
    private _countriesService:CountriesService,
    private _loaddata: LoadService,
    private _filter: FilterUrlService ) {
    this.isopen = false;
    this.primeracarga = false;
    this.alert = "";
  }

  ngOnInit() {
    this._loaddata.loadChange(15);
    this._filter.filterFirstLoad(this.settings);
    this._loaddata.loadCurrent.subscribe(a=> this.load = a);
    this.signupForm = new FormGroup({
      'id': new FormControl("-1",Validators.required),
      'rut': new FormControl(''),
      'name': new FormControl(null,Validators.required),
      'email': new FormControl(null,Validators.required),
      'address': new FormControl(null,Validators.required),
      'contact': new FormControl(''),
      'phone': new FormControl(''),
      'country_id': new FormControl(1,Validators.required)
    });
    this.loadCountries();
  }
  /**
  * carga el listado de paises
  */
  loadCountries():void{
    this._loaddata.loadChange(15);
    this._countriesService.getAll().subscribe((response:any) => {
      this.countries = response.data;
      this.loadData();
    },
    (error) => {
      this.showError(error.error.error);
    });
  }

  loadDataFiltered(filters){
    this.alert = 'Cargando información.';
    this.isopen = true;
    this._loaddata.loadChange(90);

    this._providerService.getDataFiltered(filters)
    .subscribe(
      (response:any) => {
        this.cleanForm();
        this.data_list = response.data;
        this.links = response.links;
        this.meta = response.meta;
        this._loaddata.loadChange(100);
        this.alert = "Carga Correcta."
        this.isopen =true;
        this.onClosedAutomatic();
        if(this.primeracarga === false){
          this.primeracarga = !this.primeracarga;
        }
      },
      (error) => {
        if(error.status == 0){
          this.alert = 'Busqueda sin resultados.';
          this.onClosedAutomatic();
        }
        else{
          this.showError(error.error.error);
        }
      }
    );
  }

  /**
  * Carga el listado de clientes.
  */
  loadData():void{
    this.alert = 'Cargando información.';
    this.isopen = true;
    this._loaddata.loadChange(90);

    this._providerService.get().subscribe(
      (response:any) => {
        this.cleanForm();
        this.data_list = response.data;
        this.links = response.links;
        this.meta = response.meta;
        this._loaddata.loadChange(100);
        this.alert = "Carga Correcta."
        this.isopen =true;
        this.onClosedAutomatic();
        if(this.primeracarga === false){
          this.primeracarga = !this.primeracarga;
        }
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

  /**
  * Envia a la BD los datos del formulario.
  */
  saveForm():void{
    this.alert = "Guardando proveedor.";
    this.isopen =true;
    this._loaddata.loadChange(40);

    let prov = this._providerService.transformData(this.signupForm.value);
    this._providerService.save(prov).subscribe(
      (response:any) =>{
        this._loaddata.loadChange(60);
        this.hideChildModal();
        this.loadData();
      },
        (error) => {
          this.showError(error.error.error);
        }
    );
  }

  /**
  * Envia a la BD los datos a actualizar.
  */
  updateForm():void{
    this.alert = "Actualizando proveedor.";
    this.isopen = true;
    this._loaddata.loadChange(35);

    let htmlbody = this._providerService.transformData(this.signupForm.value);
    let url = this.data_list[this.item_to_update]['links'].self;

    this._providerService.update(url, htmlbody).subscribe(
      data => {
        this._loaddata.loadChange(70);
        this.hideChildModal();
        this.alert = "Elemento actualizado.";
        this.loadData();
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

  /**
  * Elimina la fila seleccionada de la BD
  * @param  data id de la fila a eliminar
  */
  deleteItem(data):void{
    this.alert = "Eliminando proveedor.";
    this.isopen =true;
    this._loaddata.loadChange(35);

    this._providerService.delete(data.url).subscribe(
      (response:any) => {
        this._loaddata.loadChange(70);
        this.alert = "Elemento eliminado.";
        this.loadData();
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }
  /**
  * Carga la información de una fila en el formulario.
  * @param  index Indice de la fila que se carga en el formulario.
  */
  showEditForm(index) {
    this.cleanForm();
    this.item_to_update = index;
    let item = this.data_list[index];

    this.signupForm.patchValue({
      'id': item.id,
      'rut': item.attributes.rut,
      'name': item.attributes.name,
      'email': item.attributes.email,
      'address': item.attributes.address,
      'contact': item.attributes.contact,
      'phone': item.attributes.phone,
      'country_id': item.attributes.country_id
    });
    this.lgModal.show();
  }

  /**
  * Muestra el modal para crear o actualizar segun corresponda.
  * @param tipo si es crear o actualizar
  */
  showChildModal(tipo:string): void {
    if(tipo === "Crear"){
      this.title = "Crear Proveedor";
      this.isNew = true;
    } else if(tipo === "Actualizar"){
      this.title = "Actualizar Proveedor";
      this.isNew = false;
    }
    this.lgModal.show();
  }

  /**
  * Cierra el modal
  */
  hideChildModal(): void {
    this.lgModal.hide();
    this.cleanForm();
  }

  /**
  * Cierra el mensaje de alerta.
  */
  onClosed(): void {
    this.isopen = false;
  }

  /**
  * Cierra el mensaje de alerta despues de 3 segundos
  */
  onClosedAutomatic(): void {

      setTimeout(()=>{
      this.isopen = false;
    }, 3000);

  }

  /**
  * Muestra un error
  * @param  msg mensaje del error
  */
  showError(msg:string){
    if(msg == undefined){
      this.alert = 'No tiene permisos para realizar la acción.';
    }
    else{
      this.alert = msg;
    }
    this._loaddata.loadChange(100);
    this.isopen =true;
    this.onClosedAutomatic();
  }

  /**
  * Limpia el formulario para volver a utilizarlo.
  */
  cleanForm():void{
    this.signupForm.reset();
    this.signupForm = new FormGroup({
      'id': new FormControl("-1",Validators.required),
      'rut': new FormControl(''),
      'name': new FormControl(null,Validators.required),
      'email': new FormControl(null,Validators.required),
      'address': new FormControl(null,Validators.required),
      'contact': new FormControl(''),
      'phone': new FormControl(''),
      'country_id': new FormControl(1,Validators.required),
      'especificaciones':new FormArray([])
    });
  }

  /**
  * Actualiza el listado por la paginacion
  * @param data nuevo listado o mensaje de error.
  */
  updateData(data:any):void{
    if(data === "Error al cargar listado."){
      this.showError(data);
    }
    else{
      this.data_list = data;
    }
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/proveedores/proveedores.component.ts